import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo */}
        <div className="footer-logo">
          <img src="/images/Logo.png" alt="Logo" className="footer-logo-img" />
        </div>

        {/* Address and Links */}
        <div className="footer-address">
          <p>Physiotherapie Praxis</p>
          <p>Kantstrasse 40</p>
          <p>31224 Peine</p>
          <div className="footer-links">
            <a href="#impressum">Impressum</a> | 
            <a href="#datenschutz">Datenschutzerklärung</a>
          </div>
        </div>

        {/* Opening Hours */}
        <div className="footer-hours">
          <h4>Öffnungszeiten</h4>
          <table>
            <tr>
              <td style={{ textAlign: 'left' }}>
                Mo, Di, Do:<br/>
                &nbsp;
              </td>
              <td style={{ textAlign: 'right' }}>
                08:00 - 12:00<br/>
                15:00 - 18:00
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: 'left' }}>
                Mi - Fr:<br/>
                &nbsp;
              </td>
              <td style={{ textAlign: 'right' }}>
                08:00 - 12:00<br/>
                ab 12 Uhr nach Vereinbarung
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: 'left' }}>
                Sa, So:
              </td>
              <td style={{ textAlign: 'right' }}>
                Geschlossen
              </td>
            </tr>
          </table>
        </div>
      </div>
    </footer>
  );
};

export default Footer;